export const UPDATE_SECTION_DATA = 'REPORTING_UPDATE_SECTION_DATA';

export const updateSectionData = (data, pageIndex, cardIndex) => ({
  type: UPDATE_SECTION_DATA,
  pageIndex,
  cardIndex,
  data,
});
